import React from "react";
import { history } from 'react-router-guard';
import "./employees-section.component.scoped.scss";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { addLeadingZero } from "../../helpers";

export const EmployeesSectionComponent = (props: any) => {

  return (
    <div className="employees">
      <TableContainer component={Paper}>
        <Table aria-label="employees table">
          <TableHead>
            <TableRow>
              <TableCell>Rang</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Std.</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.employees.map((row: any, index: number) => (
              <EmployeeRaw index={index} info={row} key={index}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!props.employees.length && <div className="no-result">No Employees Found.</div>}
    </div>
  );
};

export const EmployeeRaw = (props: any) => {
  const {index, info} = props;

  const openEmployeePage = (row: any) => {
    history.push(`/employee/details/${row.id}`);
  };
  
  return (
    <TableRow key={index} onClick={openEmployeePage.bind(null, info)} className="employee-row">
      <TableCell component="th" scope="row">
        #&nbsp;{info.ranke}
      </TableCell>
      <TableCell>
        <div className="employee-info">
          <div className="profile-picture">
            <img
              src={info.imageURL ? info.imageURL : '/no-user.png'}
              alt=""
              className="employee-image"
            />
          </div>
          <div className="employee-name">
            {info.firstName}<br />{info.lastName}
          </div>
        </div>
      </TableCell>
      <TableCell>{addLeadingZero(info.workingHours?.hours) + ':' + addLeadingZero(info.workingHours?.minutes)}</TableCell>
  </TableRow>
  )
}